/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { triggersListDefinitions } from "../funcs/triggersListDefinitions.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListTriggerDefinitionsResult } from "../models/components/listtriggerdefinitionsresult.js";
import {
  ListTriggerDefinitionsRequest,
  ListTriggerDefinitionsSecurity,
} from "../models/operations/listtriggerdefinitions.js";
import { unwrapAsync } from "../types/fp.js";
export type TriggerDefinitionsQueryData = ListTriggerDefinitionsResult;

export function prefetchTriggerDefinitions(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListTriggerDefinitionsRequest | undefined,
  security?: ListTriggerDefinitionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildTriggerDefinitionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildTriggerDefinitionsQuery(
  client$: GramCore,
  request?: ListTriggerDefinitionsRequest | undefined,
  security?: ListTriggerDefinitionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<TriggerDefinitionsQueryData>;
} {
  return {
    queryKey: queryKeyTriggerDefinitions({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function triggerDefinitionsQueryFn(
      ctx,
    ): Promise<TriggerDefinitionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(triggersListDefinitions(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyTriggerDefinitions(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "triggers", "listDefinitions", parameters];
}
